<template>
  <div class="select-list">
    <div
      v-for="item in list"
      :key="item.id"
      class="select-item"
      :class="{
        'is-active':
          typeof value === 'string'
            ? value === (typeof item === 'string' ? item : item[valueKey])
            : value.includes(typeof item === 'string' ? item : item[valueKey]),
      }"
      @click="clickItem(item)"
    >
      {{ typeof item === "string" ? item : item[valueLabel] }}
    </div>
  </div>
</template>
<script>
export default {
  name: "EditorLabelsPicker",
  props: {
    value: {
      type: [Array, String],
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    singlePicker: {
      type: Boolean,
      default: false,
    },
    valueLabel: {
      type: String,
      default: "label",
    },
    valueKey: {
      type: String,
      default: "value",
    },
  },
  model: {
    prop: "value",
    event: "clickItem",
  },
  methods: {
    clickItem(item) {
      if (this.singlePicker) {
        this.$emit(
          "clickItem",
          typeof item === "string" ? item : item[this.valueKey]
        );
      } else {
        const value = typeof item === "string" ? item : item[this.valueKey];
        this.$emit(
          "clickItem",
          this.value.includes(value)
            ? this.value.filter((v) => v !== value)
            : [...this.value, value]
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/modal.scss";
.select-list {
  margin-bottom: 0;
}
</style>
